import RectangleDimensionInputs from '@/components/shapes/Rectangle/RectangleDimensionInputs.vue';
import RoundedRectangleDimensionInputs from '@/components/shapes/RoundedRectangle/RoundedRectangleDimensionInputs.vue';
import CircleDimensionInputs from '@/components/shapes/Circle/CircleDimensionInputs.vue';
import HalfCircleDimensionInputs from '@/components/shapes/HalfCircle/HalfCircleDimensionInputs.vue';
import QuarterCircleDimensionInputs from '@/components/shapes/QuarterCircle/QuarterCircleDimensionInputs.vue';
import EllipseDimensionInputs from '@/components/shapes/Ellipse/EllipseDimensionInputs.vue';
import SlopedRectangleDimensionInputs from '@/components/shapes/SlopedRectangle/SlopedRectangleDimensionInputs.vue';
import SlopedRightRectangleDimensionInputs from './SlopedRightRectangle/SlopedRightRectangleDimensionInputs.vue';
import RightAngledTriangleDimensionInputs from '@/components/shapes/RightAngledTriangle/RightAngledTriangleDimensionInputs.vue';
import RightAngledTriangleMirroredDimensionInputs from '@/components/shapes/RightAngledTriangleMirrored/RightAngledTriangleMirroredDimensionInputs.vue';
import IsoscelesTriangleDimensionInputs from '@/components/shapes/IsoscelesTriangle/IsoscelesTriangleDimensionInputs.vue';
import TrapezoidDimensionInputs from '@/components/shapes/Trapezoid/TrapezoidDimensionInputs.vue';
import HexagonDimensionInputs from '@/components/shapes/Hexagon/HexagonDimensionInputs.vue';
import HeartDimensionInputs from '@/components/shapes/Heart/HeartDimensionInputs.vue';
import ArrowDimensionInputs from '@/components/shapes/Arrow/ArrowDimensionInputs.vue';
import StarDimensionInputs from '@/components/shapes/Star/StarDimensionInputs.vue';
import TextDimensionInputs from '@/components/shapes/Text/TextDimensionInputs.vue';
import ArchedRectangleInputs from '@/components/shapes/ArchedRectangle/ArchedRectangleDimensionInputs.vue';
import ShapeFieldsMissing from './ShapeFieldsMissing.vue';
import { Raw } from 'vue';
import FlatOvalDimensionInputs from './FlatOval/FlatOvalDimensionInputs.vue';
import OctagonDimensionInputs from './Octagon/OctagonDimensionInputs.vue';
import DropletDimensionInputs from './Droplet/DropletDimensionInputs.vue';
import PolygonDimensionInputs from './Polygon/PolygonDimensionInputs.vue';
import EggDimensionInputs from './Egg/EggDimensionInputs.vue';
import KiteDimensionInputs from './Kite/KiteDimensionInputs.vue';
import BarrelDimensionInputs from './Barrel/BarrelDimensionInputs.vue';
import JewelDimensionInputs from './Jewel/JewelDimensionInputs.vue';
import ParallelogramDimensionInputs from './Parallelogram/ParallelogramDimensionInputs.vue';

export const getCurrentShapeInputComponent = (shape: string): Raw<any> => {
	switch (shape) {
		case 'rectangle':
			return RectangleDimensionInputs;
		case 'rounded-rectangle':
			return RoundedRectangleDimensionInputs;
		case 'circle':
			return CircleDimensionInputs;
		case 'half-circle':
			return HalfCircleDimensionInputs;
		case 'quarter-circle':
			return QuarterCircleDimensionInputs;
		case 'egg':
			return EggDimensionInputs;
		case 'ellipse':
			return EllipseDimensionInputs;
		case 'flat-oval':
			return FlatOvalDimensionInputs;
		case 'sloped-rectangle':
		case 'sloped-rectangle-flip-horizontal':
			return SlopedRectangleDimensionInputs;
		case 'sloped-right-rectangle':
		case 'sloped-right-rectangle-flip-vertical':
			return SlopedRightRectangleDimensionInputs;
		case 'right-angled-triangle':
			return RightAngledTriangleDimensionInputs;
		case 'right-angled-triangle-mirrored':
			return RightAngledTriangleMirroredDimensionInputs;
		case 'isosceles-triangle':
			return IsoscelesTriangleDimensionInputs;
		case 'trapezoid':
			return TrapezoidDimensionInputs;
		case 'hexagon':
			return HexagonDimensionInputs;
		case 'octagon':
			return OctagonDimensionInputs;
		case 'polygon':
			return PolygonDimensionInputs;
		case 'heart':
			return HeartDimensionInputs;
		case 'arrow':
			return ArrowDimensionInputs;
		case 'star':
			return StarDimensionInputs;
		case 'text':
			return TextDimensionInputs;
		case 'arched-rectangle':
			return ArchedRectangleInputs;
		case 'droplet':
			return DropletDimensionInputs;
		case 'kite':
			return KiteDimensionInputs;
		case 'barrel':
			return BarrelDimensionInputs;
		case 'jewel':
			return JewelDimensionInputs;
		case 'parallelogram-flip-horizontal':
		case 'parallelogram':
			return ParallelogramDimensionInputs;
		default:
			return ShapeFieldsMissing;
	}
};
